import { useMemo, useCallback } from 'react';
import { TIMESHEET_GROUP_BY_OPTIONS_ENUM } from '@ubeya/shared/constants';

const useGroupingColumns = ({ groupBy }) => {
  const projectIdValueGetter = useCallback((params) => params.data?.projectName, []);
  const employeeIdValueGetter = useCallback((params) => params.data?.employee?.id, []);
  const positionKeyCreator = useCallback((params) => params.data.positionId, []);
  const positionValueGetter = useCallback((params) => params.data?.positionId, []);
  const mainEventValueGetter = useCallback((params) => params.data?.mainProjectId, []);
  const noGroupByValueGetter = useCallback(() => '', []);

  return useMemo(
    () => [
      //column is hidden (used for grouping only)
      {
        colId: 'grouping-client',
        field: 'clientId',
        rowGroup: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.CLIENT,
        hide: true,
        suppressColumnsToolPanel: true
      },
      //column is hidden (used for grouping only)
      {
        colId: 'grouping-position',
        field: 'position',
        rowGroup: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.POSITION,
        keyCreator: positionKeyCreator,
        valueGetter: positionValueGetter,
        hide: true,
        suppressColumnsToolPanel: true
      },
      //column is hidden (used for grouping only)
      {
        colId: 'grouping-project',
        field: 'projectId',
        rowGroup: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.PROJECT,
        hide: true,
        suppressColumnsToolPanel: true,
        valueGetter: projectIdValueGetter
      },
      //column is hidden (used for grouping only)
      {
        colId: 'grouping-main-project',
        field: 'mainProjectId',
        rowGroup: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.MAIN_EVENT,
        hide: true,
        suppressColumnsToolPanel: true,
        valueGetter: mainEventValueGetter
      },
      //column is hidden (used for grouping only)
      {
        colId: 'grouping-date',
        field: 'date',
        rowGroup: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.DATE,
        hide: true,
        suppressColumnsToolPanel: true
      },
      //column is hidden (used for grouping only)
      {
        colId: 'grouping-employee',
        field: 'employeeId',
        rowGroup: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.EMPLOYEE,
        hide: true,
        suppressColumnsToolPanel: true,
        valueGetter: employeeIdValueGetter
      },
      //column is hidden (used for grouping only) - single catch-all group when no specific groupBy is selected
      {
        colId: 'grouping-all',
        field: 'noGroupBy',
        rowGroup: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.NO_GROUP_BY,
        hide: true,
        suppressColumnsToolPanel: true,
        valueGetter: noGroupByValueGetter
      }
    ],
    [
      groupBy,
      projectIdValueGetter,
      employeeIdValueGetter,
      positionKeyCreator,
      mainEventValueGetter,
      noGroupByValueGetter,
      positionValueGetter
    ]
  );
};

export default useGroupingColumns;
